jQuery(function($) {

    function updateUrlParameters() {
        // var tuotekategoria = $('select[name="tuotekategoria"]').val();
        var formselectuotekategoria = document.querySelector('select[name="tuotekategoria"]');
        var formselecttoimiala = document.querySelector('select[name="toimiala"]');
        var tuotekategoria = "";
        var toimiala = "";
        if (formselectuotekategoria) {
            tuotekategoria = formselectuotekategoria.options[formselectuotekategoria.selectedIndex].getAttribute("data-slug");
        }
        if (formselecttoimiala) {
            toimiala = formselecttoimiala.options[formselecttoimiala.selectedIndex].getAttribute("data-slug");
        }
        var currentUrl = window.location.href;
        var baseUrl = currentUrl.split('?')[0];
        var params = new URLSearchParams(window.location.search);
        var newUrl;

        if (tuotekategoria || toimiala) {
            if (tuotekategoria) {
                params.set('kategoria', tuotekategoria);
            }
            if (toimiala) {
                params.set('toimiala', toimiala);
            }
            newUrl = baseUrl + '?' + params.toString();
        } else {
            params.delete('kategoria');
            newUrl = baseUrl;
        }


        history.pushState({}, '', newUrl);
    }

    function selectTuotekategoriaFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var tuotekategoria = params.get('kategoria');
        var toimiala = params.get('toimiala');
        var formselectuotekategoria = document.querySelector('select[name="tuotekategoria"]');
        var formselecttoimiala = document.querySelector('select[name="toimiala"]');

        var hasparams = false;


        if (tuotekategoria && formselectuotekategoria) {
            hasparams = true;

            for (var i = 0; i < formselectuotekategoria.options.length; i++) {
                var option = formselectuotekategoria.options[i];

                if (option.dataset.slug === tuotekategoria) {
                    formselectuotekategoria.value = option.value;
                  break;  // Stop the loop since we found the matching option
                }
            }

        } else {
         //   document.querySelector('select[name="tuotekategoria"]').value = tuotekategoria;
        }

        if (toimiala && formselecttoimiala) {
            hasparams = true;

            for (var i = 0; i < formselecttoimiala.options.length; i++) {
                var option = formselecttoimiala.options[i];

                if (option.dataset.slug === toimiala) {
                    formselecttoimiala.value = option.value;
                  break;  // Stop the loop since we found the matching option
                }
            }

        } else {
         //   document.querySelector('select[name="toimiala"]').value = toimiala;
        }

        if (hasparams === true) {
            scrollToFilterAnchor();
        }


    }


    function scrollToFilterAnchor() {
        const filterAnchor = document.getElementById('filteranchor');
        if (filterAnchor) {
            const offset = document.querySelector('.site-header').offsetHeight + 30;

            const elementRect = filterAnchor.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.scrollY;
            const scrollToY = absoluteElementTop - offset;

            window.scrollTo({
                top: scrollToY,
                behavior: 'smooth'
            });
        }
    }


    var delayTimer;

    function sendRequest() {
        var filter = $('#tuotefilter');
        $('#loading').show();
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            dataType: 'json', // Set the expected response data type
            success: function(response) {
                $('#response').html(response.result);
                updateUrlParameters();
                //toggleContentButtons();
                //handleTuotePopup();
                //filterTuotekategoriat(response.tuotekategoriat);

            },
            complete: function() {
                // Hide the loading GIF image after the request is complete
                $('#loading').hide();
            }
        });
    }

    selectTuotekategoriaFromUrl();
    sendRequest();

    $('#tuotefilter .tuotteet-select').on('change', function() {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(sendRequest, 500);
    });



});

